import OpenInNewIcon from '@mui/icons-material/OpenInNew'
import { IconButton } from '@mui/material'

export const FloorPlanButton = ({ url }) => {
  if (!url) return null
  return (
    <IconButton
      aria-label="view floor plan"
      href={url}
      target="_blank"
      onClick={(e) => e.stopPropagation()}
    >
      <OpenInNewIcon fontSize="small" />
    </IconButton>
  )
}
